import { render, staticRenderFns } from "./back-info.vue?vue&type=template&id=0f30818a&scoped=true&"
import script from "./back-info.vue?vue&type=script&lang=js&"
export * from "./back-info.vue?vue&type=script&lang=js&"
import style0 from "./back-info.vue?vue&type=style&index=0&id=0f30818a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f30818a",
  null
  
)

export default component.exports